import React from 'react';
import resume from '../data/resume';

const Education = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const degreeStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0 0 5px 0',
    letterSpacing: '1px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const schoolStyle = {
    fontSize: '14px',
    margin: '0 0 5px 0',
    opacity: 0.9,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const yearStyle = {
    fontSize: '12px',
    margin: '0 0 8px 0',
    opacity: 0.7,
    fontStyle: 'italic',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const descriptionStyle = {
    fontSize: '13px',
    margin: '0',
    lineHeight: '1.4',
    opacity: 0.8,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const educationStyle = {
    marginBottom: '15px',
    padding: '10px',
    border: '1px solid #00FF00',
    backgroundColor: '#001100',
    marginLeft: 'clamp(12px, 4vw, 30px)'
  };
  const cgpaStyle = {
    fontSize: '12px',
    margin: '0 0 8px 0',
    opacity: 0.7,
    fontStyle: 'italic',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const educations = resume.education;

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ cat education.txt</div>
      <h2 style={headingStyle}>[ EDUCATION ]</h2>
      {educations.map((edu, index) => (
        <div key={index} style={educationStyle}>
          <h3 style={degreeStyle}>┌─ {edu.degree}</h3>
          <p style={schoolStyle}>│ Institution: {edu.institution}</p>
          <p style={yearStyle}>│ Period: {edu.dates}</p>
          <p style={descriptionStyle}>│ {edu.description}</p>
          <p style={cgpaStyle}>└─ CGPA: {edu.cgpa}</p>
        </div>
      ))}
    </section>
  );
};

export default Education;
